export const GET_COMPLAINTS_SUCCESS = 'GET_COMPLAINTS_SUCCESS'
export const UPDATE_COMPLAIN_SUCCESS = 'UPDATE_COMPLAIN_SUCCESS'
export const ADD_COMPLAIN_SUCCESS = 'ADD_COMPLAIN_SUCCESS'
export const DELETE_COMPLAIN_SUCCESS = 'DELETE_COMPLAIN_SUCCESS'
export const SET_FETCHING_COMPLAINTS = 'SET_FETCHING_COMPLAINTS'
